import { PropTypes } from 'prop-types'
export const Header = ({ text, isActive, className, onClick }) => {
  return (
    //     <div
    //       className='lg:mr-2 lg:max-w-80 shrink-0 snap-center '
    //       role='presentation'
    //     >
    //       <button
    //         className={`inline-block text-stone-50 lg:min-w-80 px-4 text-sm lg:text-xl leading-4 font-medium text-center
    //   ${className}`}
    //         onClick={onClick}
    //       >
    //         {text}
    //         {isActive && (
    //           <div className='flex flex-col clip'>
    //             <div className='w-full h-2 lg:h-6 bg-gradient-to-t  from-[#d9d9d9c7] via-[#d9d9d986] opacity-70 to-[#d9d9d93f] '></div>
    //             <div className='w-full h-[3px] lg:h-[5px] bg-red-500' />
    //           </div>
    //         )}
    //       </button>
    //     </div>
    <button
      role='presentation'
      className={`whitespace-nowrap shrink-0 snap-start text-white ${
        isActive ? 'font-bold' : 'font-semibold '
      } text-lg border-b-4 px-4 pb-1 transition-all ${
        isActive ? 'border-[#FF4D4D]' : 'border-transparent'
      } transition-all ${className}`}
      onClick={onClick}
    >
      {text}
    </button>
  )
}

Header.propTypes = {
  text: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func
}
